/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPurchaseorderPopupreceivedCtrl
 */
angular.module('mercury.modules.stock.purchaseorder')
.controller('StockPurchaseorderPopupreceivedCtrl', ["dialog", "$q", "$scope", "$stateParams", "StockItems", "StockReceived", function(dialog, $q, $scope, $stateParams, StockItems, StockReceived) {
  $scope.stockReceived = StockReceived.getStockReceivedsByDateRange($stateParams.startTime, $stateParams.endTime, 'Received', $stateParams.itemId)
  $scope.item = StockItems.get($stateParams.itemId);

  $scope.loading = $q.all([$scope.stockReceived.$promise, $scope.item.$promise])
  $scope.loading.then(function() {
    $scope.totalQuantity = 0;
    $scope.totalCost = 0; 

    $scope.stockReceived = $scope.stockReceived.map(function(stockReceivedDoc) {
      
      // It is possible for invoices to have more that one line with the same item
      var relevantLines = stockReceivedDoc.lines.filter(function(line) {
        return line.itemId == $stateParams.itemId
      })

      var relevantLine = relevantLines[0]

      // If there is multiple lines with the same item combine them
      // Notes: This will choose the largest priced line as the unit cost.
      //        Also assumes that the unit and line tax remains the same between the lines.
      if (relevantLines.length > 1) {
        for (var idx in relevantLines) {
          // Skip first line as we already have this line stored in `relevantLine`
          if (idx == 0) continue;

          var currentLine = relevantLines[idx]
          
          // If one line has a greater cost than another choose the greater cost to display
          // there is no reasoning as to why we do that, it just felt like the best option 
          if (currentLine.unitCost > relevantLine.unitCost){
            relevantLine.unitCost = currentLine.unitCost
          }

          relevantLine.quantityReceived += currentLine.quantityReceived
        }
      }

      $scope.totalQuantity += relevantLine.quantityReceived;
      $scope.totalCost += relevantLine.quantityReceived * relevantLine.unitCost;

      return {
        id: relevantLine.id,
        parentDocumentId: stockReceivedDoc.id,
        type: stockReceivedDoc.type,
        documentNumber: stockReceivedDoc.type == 'Invoice' ? 
          (stockReceivedDoc.creditRequest ? 'CN' : 'INV') + ' #' + stockReceivedDoc.invoiceNumber :
          (stockReceivedDoc.creditRequest ? 'CR' : 'PO') + ' #' + stockReceivedDoc.purchaseOrderNumber,
        datestampReceived: stockReceivedDoc.receivedAt,
        datestampInvoiced: stockReceivedDoc.invoicedAt,
        creditRequest: stockReceivedDoc.creditRequest,
        supplierId: stockReceivedDoc.supplierId,
        orderedBy: stockReceivedDoc.orderedBy,
        stockItemId: relevantLine.itemId,
        unitCost: relevantLine.unitCost,
        quantity: relevantLine.quantityReceived,
        lineTax: relevantLine.saleTaxRate,
        unitName: relevantLine.unitName
      }
    })
  });
}]);
